import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip
} from '@mui/material';
import { Edit, Delete, Description } from '@mui/icons-material';
import { ROLES } from '../../constants/roles';

/**
 * PartsCatalogTable Component
 * Displays the parts table with actions
 */
const PartsCatalogTable = ({
  parts,
  loading,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  onManageDocuments
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Part Number</TableCell>
            <TableCell>Reference Part Number</TableCell>
            <TableCell>Part Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Manufacturer</TableCell>
            <TableCell>Primary Model</TableCell>
            <TableCell>Unit Metric</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={10} align="center">
                Loading...
              </TableCell>
            </TableRow>
          ) : parts.length === 0 ? (
            <TableRow>
              <TableCell colSpan={10} align="center">
                No parts found
              </TableCell>
            </TableRow>
          ) : (
            parts.map((part) => (
              <TableRow key={part._id}>
                <TableCell>{part.partNumber}</TableCell>
                <TableCell>{part.referencePartNumber || '—'}</TableCell>
                <TableCell>{part.partName || '—'}</TableCell>
                <TableCell>{part.description}</TableCell>
                <TableCell>{part.category?.name || '-'}</TableCell>
                <TableCell>
                  {part.manufacturers && Array.isArray(part.manufacturers) && part.manufacturers.length > 0
                    ? part.manufacturers.map(m => m?.name || m).filter(Boolean).join(', ')
                    : part.manufacturer?.name || '-'}
                </TableCell>
                <TableCell>
                  {part.primaryModels && Array.isArray(part.primaryModels) && part.primaryModels.length > 0
                    ? part.primaryModels.map(m => m?.name || m).filter(Boolean).join(', ')
                    : part.model?.name || '-'}
                </TableCell>
                <TableCell>{part.unitMetric}</TableCell>
                <TableCell>
                  <Chip
                    label={part.isActive ? 'Active' : 'Archived'}
                    color={part.isActive ? 'success' : 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {canEdit && (
                    <>
                      <IconButton
                        size="small"
                        onClick={() => onEdit(part)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => onManageDocuments(part)}
                        title="Manage Documents"
                      >
                        <Description />
                      </IconButton>
                    </>
                  )}
                  {canDelete && (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => onDelete(part._id, part.partNumber)}
                    >
                      <Delete />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PartsCatalogTable;
